import type { ReactNode } from 'react'
import { BarChart3, Map, Users, Wallet } from 'lucide-react'

export type CommandCenterCapability = {
  key: string
  label: string
  description: string
  icon: ReactNode
}

export const COMMAND_CENTER_CAPABILITIES: CommandCenterCapability[] = [
  {
    key: 'analytics',
    label: 'Advanced Analytics',
    description:
      'Species by blind, utilization against pressure, and this season measured against last.',
    icon: <BarChart3 size={18} className="text-blaze" aria-hidden />,
  },
  {
    key: 'finances',
    label: 'Financial Management',
    description:
      'Expenses by category and vendor, plus a running balance, charges, and statements for every member.',
    icon: <Wallet size={18} className="text-blaze" aria-hidden />,
  },
  {
    key: 'roster',
    label: 'Roster Management',
    description:
      'Invite members and guides, set what each seat can see, and keep licenses and signed waivers on file.',
    icon: <Users size={18} className="text-blaze" aria-hidden />,
  },
  {
    key: 'property',
    label: 'Property & Scheduling',
    description:
      'Map every blind, zone, and stand, then schedule who hunts where with double-bookings caught up front.',
    icon: <Map size={18} className="text-blaze" aria-hidden />,
  },
]
